import { Layout, Orientation } from '../../components/handler-components/ResizeHandler';
import { EVENT_DETAIL_DISPLAY_TYPE } from '../../data-types/sports/sportsEnums';
import {
  NavigationActionType,
  NavigationState,
  SET_DESKTOP_PROFILE_PATH,
  SET_DESKTOP_RENDER_HELP_OPEN,
  SET_EVENT_DETAIL_VIEW_TYPE,
  SET_FADE_OUT_OVERLAY_DATA,
  SET_HEIGHT,
  SET_LAYOUT,
  SET_ORIENTATION,
  SET_PREVENT_REDIRECT_ON_ERROR,
  SET_SEARCH_TEXT,
  SET_SEARCH_TYPE,
  SET_SELECTED_BET_SIDE_BAR_TAB,
  SET_SELECTED_SUB_NAV_ITEM,
  SET_SPORTS_MENU,
  SET_VERIFICATION_OVERLAY,
  SET_WIDTH,
} from '../types/navigationTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialNavigationState: NavigationState = {
  verificationOverlayOpen: false,
  desktopProfilePath: undefined,
  renderDesktopHelpOpen: false,
  preventRedirectOnError: false,
  fadeOutOverlay: {
    open: false,
    zIndex: 0,
  },
  eventDetailDisplayType: EVENT_DETAIL_DISPLAY_TYPE.SPLIT,
  sportsMenu: {
    menu: undefined,
    tabs: undefined,
    subTabs: undefined,
    inPlaySubTabs: undefined,
  },
  search: {
    searchTerm: '',
    searchType: undefined,
  },
  selectedBetSideBarTab: undefined,
  layout: Layout.MOBILE,
  width: window ? window.innerWidth : 0,
  height: window ? window.innerHeight : 0,
  orientation: Orientation.PORTRAIT,
  selectedSubNavItem: undefined,
};

export const navigationReducer = (state = initialNavigationState, action: NavigationActionType): NavigationState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialNavigationState,
        sportsMenu: state.sportsMenu,
        width: state.width,
        layout: state.layout,
        orientation: state.orientation,
      };
    case SET_SEARCH_TEXT:
      return { ...state, search: { ...state.search, searchTerm: action.meta } };
    case SET_SEARCH_TYPE:
      return { ...state, search: { ...state.search, searchType: action.meta } };
    case SET_VERIFICATION_OVERLAY: {
      return state.verificationOverlayOpen === action.meta ? state : { ...state, verificationOverlayOpen: action.meta };
    }
    case SET_DESKTOP_PROFILE_PATH: {
      return { ...state, desktopProfilePath: action.meta };
    }
    case SET_DESKTOP_RENDER_HELP_OPEN: {
      return { ...state, renderDesktopHelpOpen: action.meta };
    }
    case SET_PREVENT_REDIRECT_ON_ERROR: {
      return { ...state, preventRedirectOnError: action.meta };
    }
    case SET_FADE_OUT_OVERLAY_DATA: {
      return { ...state, fadeOutOverlay: action.meta };
    }
    case SET_EVENT_DETAIL_VIEW_TYPE: {
      return { ...state, eventDetailDisplayType: action.meta };
    }
    case SET_SPORTS_MENU:
      return { ...state, sportsMenu: action.meta };
    case SET_SELECTED_BET_SIDE_BAR_TAB:
      return { ...state, selectedBetSideBarTab: action.meta };
    case SET_LAYOUT:
      return { ...state, layout: action.meta };
    case SET_WIDTH:
      return { ...state, width: action.meta };
    case SET_HEIGHT:
      return { ...state, height: action.meta };
    case SET_ORIENTATION:
      return { ...state, orientation: action.meta };
    case SET_SELECTED_SUB_NAV_ITEM:
      return { ...state, selectedSubNavItem: action.meta };
    default:
      return state;
  }
};
